import { createSlice } from '@reduxjs/toolkit';

export const provinceSlice = createSlice({
  name: 'province',
  initialState: {},
  reducers: {
    setList: (state, action) => {
  
      state[
        action.payload.prefix
          ? `${action.payload.prefix}province`
          : 'province'
      ] = action.payload.provinces || {}
      
    }
  }
})


export const { setList } = provinceSlice.actions;

export default provinceSlice.reducer;